import { render, staticRenderFns } from "./CategoryCheckboxSelect.vue?vue&type=template&id=6b7c4654"
import script from "./CategoryCheckboxSelect.vue?vue&type=script&lang=js"
export * from "./CategoryCheckboxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports